import { render, staticRenderFns } from "./biz-notifications.vue?vue&type=template&id=24bcbbdd&scoped=true&lang=pug&"
import script from "./biz-notifications.vue?vue&type=script&lang=js&"
export * from "./biz-notifications.vue?vue&type=script&lang=js&"
import style0 from "./biz-notifications.vue?vue&type=style&index=0&id=24bcbbdd&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcbbdd",
  null
  
)

export default component.exports